/**
 * Content-Type header.
 *
 *
 * @beta
 */
export const CONTENT_TYPE = 'Content-Type'
